import { Hub } from 'aws-amplify'
import { useEffect } from 'react'
import { useLocation } from 'react-router'

export const useUrlLogoutListener = () => {
  const location = useLocation()

  useEffect(() => {
    if (location.pathname === '/logout') {
      Hub.dispatch('auth', { event: 'signOut' })
    }
  }, [location.pathname])
}
